var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSnapshots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5778 3.19711C17.0203 1.75461 19.3599 1.75461 20.8024 3.19711C22.2449 4.6396 22.2449 6.97922 20.8024 8.42172L8.42153 20.8026C8.31176 20.9123 8.17721 20.9947 8.02993 21.0438L2.31607 22.9481C1.95673 23.0679 1.56046 22.9747 1.29263 22.7069C1.0248 22.439 0.931639 22.0428 1.05142 21.6834L2.95571 15.9696L2.99868 15.8612C3.04779 15.7564 3.11467 15.6602 3.19693 15.578L15.5778 3.19711ZM19.3874 4.61214C18.7259 3.9507 17.6543 3.9507 16.9928 4.61214L4.777 16.827L3.57974 20.4188L7.17153 19.2215L19.3874 7.00668C20.0488 6.34523 20.0488 5.27359 19.3874 4.61214Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C21 18 23 17.7885 23 18.5C23 19.2115 21 19 20 20C19 21 19.2365 23 18.5 23C17.7635 23 18 21 17 20C16 19 14 19.2707 14 18.5C14 17.7293 16 18 17 17C18 16 17.7517 14 18.5 14C19.2483 14 19 16 20 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H2C1.44772 4 1 3.55228 1 3C1 2.44772 1.44772 2 2 2H12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H2C1.44772 8 1 7.55228 1 7C1 6.44772 1.44772 6 2 6H8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSnapshots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconSnapshots.100edbc99b0cd467c965cd1ae880e37e.svg";